import {
  Avatar,
  Box,
  Card,
  CardHeader,
  Link,
  Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

const useStyles = makeStyles(() => ({
  root: {},
  date: {
    marginLeft: 6
  }
}));

const Comment = ({ className, comment, ...rest }) => {
  const classes = useStyles();

  return (
    <>
      <Card className={clsx(classes.root, className)} {...rest}>
        <CardHeader
          avatar={
            <Avatar
              alt="Person"
              className={classes.avatar}
              src={comment.author?.avatar}
            />
          }
          disableTypography
          subheader={
            <Box display="flex" alignItems="center">
              {comment.dateCreated && (
                <>
                  <AccessTimeIcon fontSize="small" />
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    className={classes.date}
                  >
                    {comment.dateCreated}
                  </Typography>
                </>
              )}
            </Box>
          }
          title={
            <Link
              color="textPrimary"
              component={RouterLink}
              to="#"
              variant="h6"
            >
              {comment.createdBy}
            </Link>
          }
        />
        <Box px={3} pb={2}>
          <Typography variant="body1" color="textPrimary">
            {comment.commentType}
          </Typography>
        </Box>
        <Box px={3} pb={2}>
          <Typography variant="body1" color="textPrimary">
            {comment.message}
          </Typography>
        </Box>
      </Card>
    </>
  );
};

Comment.propTypes = {
  className: PropTypes.string,
  comment: PropTypes.object
};

export default Comment;
